import React, { useEffect, useState } from "react";
import "./propertyinfonew/BossPlans.css";
import { useParams } from "react-router-dom";
import { Baseurl, Baseurl2 } from "../config/BaseUrl";
import axios from "axios";
import Subbanner from "./propertyinfonew/Subbanner";
import Overview from "./propertyinfonew/Overview";
import Dealerdetails from "./propertyinfonew/Dealerdetails";
import Registryrecord from "./propertyinfonew/Registryrecord";
import Explorelocality from "./propertyinfonew/Explorelocality";
import Recommendation from "./propertyinfonew/Recommendation";
import Articles from "./propertyinfonew/Articles";
import Society from "./propertyinfonew/Society";
import { ColorRing } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import {
  setPropertyInfoSingleProperty,
  setPropertyInfoSinglePropertyCheck,
} from "../redux/property/PropertySlice";
import PgSubbanner from "./propertyinfonew/PgSubbanner";
import PlotLandSubbanner from "./propertyinfonew/PlotLandSubbanner";
import CommercialSubbanner from "./propertyinfonew/CommercialSubbanner";
import RentOverView from "./propertyinfonew/RentOverView";
import PgOverView from "./propertyinfonew/PgOverView";
import CommercialOverview from "./propertyinfonew/CommercialOverview";
import PlotLandOverview from "./propertyinfonew/PlotLandOverview";
import ResidentialOverview from "./propertyinfonew/ResidentialOverview";
import OfficeOverview from "./propertyinfonew/OfficeOverview";
import RetailSubBanner from "./propertyinfonew/RetailSubBanner";
import ModernPropertyDetail from "./propertyinfonew/ModernPropertyDetail";
import RetailOverview from "./propertyinfonew/RetailOverview";
import OtherSubBanner from "./propertyinfonew/OtherSubBanner";
import OtherOverview from "./propertyinfonew/OtherOverview";
import FarmhouseOverview from "./propertyinfonew/FarmhouseOverview";
import OfficeComSubbanner from "./propertyinfonew/OfficeComSubbanner";
import {
  WhatsappShareButton,
  WhatsappIcon,
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
} from "react-share";

const PropertyInfoNew = () => {
  const params = useParams();
  const dispatch = useDispatch();

  const [property, setProperty] = useState({});
  const [propertyRule, setPropertyRule] = useState({});
  const [propertyIncludePrice, setPropertyIncludePrice] = useState({});
  const [propertyImages, setPropertyImages] = useState([]);
  const [propertyImagesWithName, setPropertyImagesWithName] = useState([]);
  const [propertySingleImage, setPropertySingleImage] = useState("");
  const [tempLoading, setTempLoading] = useState(true);

  useEffect(() => {
    const targetPropertyId = params.propertyid || params.apartname;
    const loadData = async () => {
      try {
        if (targetPropertyId && targetPropertyId !== "") {
          const url = `${Baseurl}/api/v1/property/propertybyprojectid/${targetPropertyId}`;
          const fetchProperty = await axios(url);
          if (fetchProperty.data.success === true && fetchProperty.data.property) {
            let singleProperty = fetchProperty.data.property;
            setProperty(singleProperty);
            setPropertyRule(singleProperty.houseRules || {});
            setPropertyIncludePrice(singleProperty.includesprice || {});
            setPropertyImages(singleProperty.DeskImg || []);
            setPropertySingleImage(singleProperty.thumbnail || "");
            setPropertyImagesWithName(singleProperty.titleImg || []);
            setTempLoading(false);
            return;
          }
        }

        // If targetPropertyId wasn't found or wasn't provided (e.g. direct /property-info), load default property from API
        const fallbackUrl = `${Baseurl2}/api/v1/property/all`;
        const fallbackRes = await axios(fallbackUrl);
        if (
          fallbackRes.data &&
          fallbackRes.data.property &&
          fallbackRes.data.property.length > 0
        ) {
          let singleProperty = fallbackRes.data.property[0];
          setProperty(singleProperty);
          setPropertyRule(singleProperty.houseRules || {});
          setPropertyIncludePrice(singleProperty.includesprice || {});
          setPropertyImages(singleProperty.DeskImg || []);
          setPropertySingleImage(singleProperty.thumbnail || "");
          setPropertyImagesWithName(singleProperty.titleImg || []);
          setTempLoading(false);
        } else {
          setTempLoading(false);
        }
      } catch (error) {
        console.error("Error loading property details:", error);
        setTempLoading(false);
      }
    };
    loadData();
  }, [params.apartname, params.propertyid]);

  const currentUrl = window.location.href;

  return (
    <div style={{ width: "100%", maxWidth: "100vw", overflowX: "hidden", position: "relative" }}>
      {tempLoading ? (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "20vh",
            }}
          >
            <ColorRing
              visible={true}
              height="80"
              width="80"
              ariaLabel="blocks-loading"
              wrapperStyle={{}}
              wrapperClass="blocks-wrapper"
              colors={["#e15b64", "#f47e60", "#f8b26a", "#abbd81", "#849b87"]}
            />
          </div>
        </>
      ) : (
        <ModernPropertyDetail
          singlProperty={property}
          propertyRule={propertyRule}
          propertyIncludePrice={propertyIncludePrice}
          propertyImages={propertyImages}
          propertyImagesWithName={propertyImagesWithName}
          propertySingleImage={propertySingleImage}
        />
      )}
      <div className="whatsappcontainer1">
        <div className="whatsappcontainer">
          <WhatsappShareButton url={currentUrl} title="EwRealty">
            <WhatsappIcon size={32} round={true} />
          </WhatsappShareButton>
          <div style={{ marginTop: "5px", marginBottom: "6px" }}>
            <FacebookShareButton url={currentUrl} title="EwRealty">
              <FacebookIcon size={32} round={true} />
            </FacebookShareButton>
          </div>
          <div style={{ marginBottom: "16px" }}>
            <TwitterShareButton url={currentUrl} title="EwRealty">
              <TwitterIcon size={32} round={true} />
            </TwitterShareButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyInfoNew;
